import React, { forwardRef } from 'react';
import { FormControl } from '@tangibleplay/core-ui';

/**
 * Default input text if no other component is specified
 */
const DefaultInputForForms = forwardRef<HTMLInputElement>(
  (
    {
      name,
      value,
      error,
      onChange,
      autoComplete,
      placeholder,
      maxLength,
      label,
      required,
      disabled,
    }: any,
    ref,
  ) => (
    <FormControl
      formControlLabel={label}
      formControlName={name}
      isRequired={required}
      additionalContent={error}
    >
      <input
        type="text"
        ref={ref}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        maxLength={maxLength}
        disabled={disabled}
      />
    </FormControl>
  ),
);

export default DefaultInputForForms;
